import React from "react"
import { useSelector } from "react-redux"

import LocationPicker from "@containers/LocationPicker"
import Search from "@containers/Search"

import { isDwebUrl } from "@lib/urlMatchUtility"

import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"

import Button from "@components/Button/Button"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import { sendMixpanelTrackEvent } from "@lib/gtmUtility"

const SubHeader = () => {
    const { showSubLocation, showSubSearch, showSubQuickOrder, cartType, pageName } = useSelector(
        (state) => state.shellReducer
    )

    const isLabs = cartType === "labs" ? true : false
    const subQuickOrderText = isLabs ? "Upto 50% Off" : "QUICK BUY! Get 25% off on medicines*"
    const primaryButtonRedirectUrl = isLabs ? "/labs/order-with-prescription" : "/order-with-prescription"
    const primaryButtonCTA = isLabs ? "Book Test From Prescription" : "Quick order"

    return (
        <div className="padding-0-32 flex justifyBetween padding-8-0 alignCenter">
            <div className="col-16 flex" style={{ gap: "2px" }}>
                {showSubLocation && <LocationPicker />}
                {showSubSearch && <Search />}
            </div>
            {showSubQuickOrder && (
                <div className="flex alignCenter">
                    <div className="flex alignCenter bodyMedium textPrimary insetDivider">
                        <ImageLoader
                            src="https://onemg.gumlet.io/quick_buy_rebrand_lqpnce.svg"
                            width="24px"
                            height="24px"
                        />
                        <div>{subQuickOrderText}</div>
                    </div>
                    <ConditionalLink
                        onClick={() => {
                            sendMixpanelTrackEvent("non_sku_widget_clicked", {
                                business_unit: "shared",
                                page_name: pageName,
                                category_name: "quick_order",
                                cta_type: primaryButtonCTA,
                                target_url: primaryButtonRedirectUrl,
                            })
                        }}
                        to={primaryButtonRedirectUrl}
                        isExternal={!isDwebUrl(primaryButtonRedirectUrl)}
                    >
                        <Button label={primaryButtonCTA} />
                    </ConditionalLink>
                </div>
            )}
        </div>
    )
}

export default SubHeader
